import { useState, useEffect } from 'react';

export const useProjects = (initialProjectsData, setSelectedFilters) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [currentProjects, setCurrentProjects] = useState([]);

    useEffect(() => {
        if (initialProjectsData) {
            setCurrentPage(initialProjectsData.current_page);
            setPageCount(initialProjectsData.last_page);
            setCurrentProjects(initialProjectsData.data);
        }
    }, [initialProjectsData]);

    const handlePageChange = (page) => {
        if (page !== currentPage) {
            setCurrentPage(page); // Update current page state
            setSelectedFilters(prevFilters => ({
                ...prevFilters,
                page // Update filters with the new page
            }));
        }
    };

    return {
        currentProjects,
        currentPage,
        pageCount,
        handlePageChange,
        setCurrentPage,
    };
};
